import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from "react-confirm";
import { Modal } from "react-bootstrap";
import { UPVOTE, DOWNVOTE } from "./constants/vote-types";
import { UserResource } from "./proptypes/user-resource";

const ElectionVoteConfirmable = (props) => {
    const {
        show,
        proceed,
        dismiss,
        user,
    } = props;

    const [reason, setReason] = useState("");

    const onSubmit = async (type) => proceed({ type, reason });

    return (
        <Modal
            className="text-black"
            show={show}
            onHide={dismiss}
            centered
        >
            <Modal.Header className="border-0" closeButton />
            <Modal.Body className="border-0">
                <div className="text-center">
                    <p className="h4 mb-3">Confirm your vote</p>
                    <p>Please cast your vote for {user.username}. Your vote will only be visible to admins. Please note that you will only be able to cast your vote once.</p>
                </div>
                <div className="mb-3">
                    <textarea
                        className="form-control"
                        placeholder="Please provide your reasoning for your choice"
                        maxLength="2000"
                        onChange={e => setReason(e.target.value)}
                    />
                    <p className="small text-danger text-end">* reason is a required field</p>
                </div>
                <div className="d-flex justify-content-center mb-3">
                    <button
                        className="btn btn-danger me-3"
                        type="button"
                        onClick={() => onSubmit(DOWNVOTE)}
                        disabled={!reason}
                    >
                        Vote Down
                    </button>
                    <button
                        className="btn btn-success"
                        type="submit"
                        onClick={() => onSubmit(UPVOTE)}
                        disabled={!reason}
                    >
                        Vote Up
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};


ElectionVoteConfirmable.propTypes = {
    show: PropTypes.bool.isRequired,
    proceed: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    dismiss: PropTypes.func.isRequired,
    user: PropTypes.shape(UserResource),
};

export function electionVoteConfirm({ user }) {
    return createConfirmation(confirmable(ElectionVoteConfirmable))({ user });
};
